var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.3422 1.43969C15.3711 1.38107 15.4 1.32244 15.4 1.26382C15.4 1.11725 15.2844 1 15.1398 1C15.082 1 15.0241 1.02931 14.9663 1.05863L8.20002 7.91786L1.40484 1.05863C1.37593 1.02931 1.3181 0.999999 1.26027 0.999999C1.11569 0.999999 1.00002 1.11725 1.00002 1.26382C1.00002 1.32244 1.02894 1.38107 1.05786 1.43969L7.82412 8.29893L8.17111 8.65069L15.3422 1.43969Z","fill":"white","stroke":"white"}));
}

Arrow.defaultProps = {"width":"16","height":"10","viewBox":"0 0 16 10","fill":"none"};

module.exports = Arrow;

Arrow.default = Arrow;
